/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const generateTitleAudioBatchBodySchema = z.object({
  challengeIds: z.array(z.number()).min(1).max(10),
});

export type IGenerateTitleAudioBatchBody = z.infer<typeof generateTitleAudioBatchBodySchema>;
